import { FeatureappServiceV1Impl } from '@volkswagen-onehub/featureapp-service';
import { Dependencies } from 'src/feature-app';
import { useFeatureAppEnvironment } from './use-feature-app-environment';

export function useFeatureAppService(): FeatureappServiceV1Impl {
  const { featureServices } = useFeatureAppEnvironment();

  return featureServices['featureapp-service'];
}
